module.exports = __webpack_public_path__ + "static/media/lesson-backto13.12185508.png";